<template>
  <div>
    <b-modal v-model="value" size="lg" centered no-close-on-esc no-close-on-backdrop>
      <template #modal-header>
        <div class="w-100">
          <b-icon-x
            font-scale="2"
            @click="close()"
            variant="secondary"
            class="float-right cursor-pointer"
          />
        </div>
      </template>

      <b-overlay :show="isLoading" spinner-variant="secondary" rounded="sm">
        <div v-if="!isLoading">
          <div v-for="(block, index) in blocks" :key="index">
            <div v-if="currentStep === index + 1">
              <stream-block-container :block="block" :user-id="userId" is-in-modal />
            </div>
          </div>
        </div>
      </b-overlay>

      <template #modal-footer>
        <div class="w-100 modal-footer-btns" v-if="!isLoading">
          <b-button variant="link" class="float-left" @click="prevStep()" v-if="currentStep !== 1">
            {{ trans("onboarding.back") }}
          </b-button>
          <b-button
            variant="secondary"
            class="float-right"
            :disabled="disableNext"
            @click="nextStep()"
          >
            <span
              v-if="disableNext"
              class="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            />
            {{ trans("onboarding.continue") }}
          </b-button>
        </div>
        <div class="w-100 text-center" v-if="!isLoading">
          <p class="text-opacity mb-0">{{ currentStep }}/{{ blocks.length }}</p>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import TextBlock from "../stream-page/blocks/TextBlock";
import TextWithImageVertical from "../stream-page/blocks/TextWithImageVertical";
import { mapActions, mapGetters, mapMutations } from "vuex";
import StreamBlockContainer from "../StreamBlockContainer";
import streamMixin from "../../mixins/streamMixin";

export default {
  name: "MiuModal",
  props: {
    value: Boolean,
    miuId: String,
    streamId: String,
    hasRedirect: String,
    currentMiuCompleted: Boolean,
  },
  components: {
    TextBlock,
    TextWithImageVertical,
    StreamBlockContainer,
  },
  data() {
    return {
      miuModalShow: false,
      currentStep: 1,
      elementType: "miu",
      disableNext: false,
    };
  },
  methods: {
    ...mapActions({
      loadMiu: "streams/loadMiu",
      submitActivity: "streams/submitElement",
    }),
    ...mapMutations({
      setMiuCompleted: "streams/setMiuCompleted",
      setProgressUpdate: "streams/setProgressUpdate",
    }),
    prevStep() {
      this.currentStep--;
    },
    async nextStep() {
      if (!this.isLastStep) {
        this.currentStep++;
      } else {
        this.disableNext = true;
        await this.completeActivity(
          this.miuId,
          this.elementType,
          this.streamId,
          this.elementSoftSkills
        );
        trackEvent("StreamElementComplete", this.trackingInfo);
        this.$emit("toggle");
        this.setMiuCompleted(this.miuId);
        if (!this.currentMiuCompleted) {
          this.setProgressUpdate();
        }
        if (this.hasRedirect) {
          this.$router.push(this.hasRedirect);
        }
      }
    },
    close() {
      this.$emit("toggle");
      this.setLoading(true);
    },
  },
  mounted() {
    this.loadMiu(this.miuId);
    trackEvent("StreamElementView", this.trackingInfo);
  },
  computed: {
    ...mapGetters({
      blocks: "streams/getMiuBlocks",
      userId: "user/getUserId",
      isLoading: "streams/getLoadingPageState",
      elementSoftSkills: "streams/getElementSoftSkill",
      aleId: "streams/getCurrentAleId",
    }),
    isFirstStep() {
      return this.currentStep === 1;
    },
    isLastStep() {
      return this.blocks.length === this.currentStep;
    },
    modalVisibility() {
      return (this.miuModalShow = this.value);
    },
    trackingInfo() {
      return {
        streamId: this.streamId,
        aleId: this.aleId,
        miuId: this.miuId,
        userId: this.userId,
        elementType: "miu",
        numberOfBlock: this.blocks.length,
        onboarding: true,
      };
    },
  },
  mixins: [streamMixin],
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-header {
    padding-bottom: 0;
  }
  .modal-body {
    padding-top: 0;

    .py-4:not(.block-header) {
      padding: 0 !important;
    }
  }
  .modal-footer {
    padding-top: 0;

    .modal-footer-btns {
      @media (max-width: 768px) {
        .btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
